import React, { ReactNode, useState } from "react";
import { Placeholder } from "@bloomberg/media-ui-article";
import { ViewportElement } from "@foundation/viewport-element";

type ViewportComponentProps = {
    onRender: (inViewport: boolean) => ReactNode;
    wrapperClasses?: string;
    rootMargin?: string;
    showPlaceholder?: boolean;
    placeholderClasses?: string;
};

const ViewportComponent = ({
    onRender,
    showPlaceholder,
    placeholderClasses = "h-[250px]",
    wrapperClasses,
    rootMargin = "0px 0px 500px 0px",
}: ViewportComponentProps) => {
    const [inViewport, setViewportState] = useState(false);

    return (
        <ViewportElement
            className={wrapperClasses}
            rootMargin={rootMargin}
            onEnter={() => setViewportState(true)}
            once
        >
            {showPlaceholder && !inViewport && (
                <div className={placeholderClasses}>
                    <Placeholder.Image />
                </div>
            )}
            {onRender(inViewport)}
        </ViewportElement>
    );
};

export default ViewportComponent;
